import {
	appVersionRaw,
	sentryReleaseAnalytics,
} from '@jepto/environments/app-version.generated';

export const environment = {
	production: false,
	staging: true,
	develop: false,
	hostName: 'https://stg.jepto.com',
	appSyncConfig: {
		graphqlEndpoint:
			'https://woj6dfvlfbhbngogge4wmor65m.appsync-api.ap-southeast-1.amazonaws.com/graphql',
		customEndpoint: 'https://stg.api.jepto.com/graphql',
		eventsEndpoint: 'https://stg.event.jepto.com/event',
		region: 'ap-southeast-1',
		authenticationType: 'iam',
	},
	cognitoSettings: {
		identityPoolId: 'ap-southeast-1:33f3f013-423a-4346-9d4e-a664cbe02c19',
		UserPoolId: 'ap-southeast-1_2peJmBtUq',
		ClientId: '7jkdas9ekeminjq171u6v91uvi',
	},
	sentry: {
		enabled: true,
		dsn: 'https://38a20e46129d18839d8b43c884faf76a@o4510870850437120.ingest.us.sentry.io/4510870852403200',
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.01,
		replaysOnErrorSampleRate: 1.0,
		debug: false,
	},
	appVersion: `v${appVersionRaw}`,
	appVersionRaw,
	sentryRelease: sentryReleaseAnalytics,
	/** POST target for REPORT_VIEWED events; verify IAM + volume here before enabling prd. */
	reportViewUrl: 'https://stg.api.app.jepto.com/report/view',
	reportViewTrackingEnabled: true,
};
